import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ACCESS_CONFIG, NESTED_SIDENAV, SETTINGS } from "../strings";
import NestedTabsComponent from "../nested-tabs-component";

const UserLayout = () => {
  const { t } = useTranslation();
  const { MARKETING_MANAGER_TIER } = ACCESS_CONFIG;

  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">{t("sidebar.settings")}</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.SETTING}
            tabs={[
              {
                evKey: SETTINGS.PROFILE,
                title: t("sidebar.profile"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: SETTINGS.SECURITY,
                title: t("common.security"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: SETTINGS.CHANGE_PASSWORD,
                title: t("common.changePassword"),
                access: MARKETING_MANAGER_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default UserLayout;
